import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param payload
 */
class WhatsappIntegrationServices {
  /**
 * @param orgId
 * @param {*} payload
 * @return
 */
getWhatsappConnections = async (orgId) => {
  let url = `${Constants.GET_WHATSAPP_CONNECTIONS}`;
  if (orgId) url += `?org_id=${orgId}&`;
  const getWhatsappConnections = await Helpers.get({
    url,
  });
  return getWhatsappConnections;
}

updateWhatsappConfiguration = async (payload) => {
  const updateWhatsappConfigurationData = await Helpers.post({
    url: Constants.UPDATE_WHATSAPP_CONFIGURATION,
    data: payload,
  });
  return updateWhatsappConfigurationData;
}

  /**
 *
 * @param {*} payload
 * @return
 */
  toggleWhatsapp = async (payload) => {
    const toggleWhatsapp = await Helpers.post({
      url: Constants.TOGGLE_WHATSAPP,
      data: payload,
    });
    return toggleWhatsapp;
  }

  sendWhatsappNotification = async (payload, entityName) => {
    const sendWhatsappNotification = await Helpers.post({
      url: `${Constants.BASE_URL}/${entityName}/send/whatsapp`,
      data: payload,
    });
    return sendWhatsappNotification;
  }
}

export default new WhatsappIntegrationServices();
